import React, { Component } from 'react';

import './Help.scss';

class Help extends Component {

    render() {
        
        return (<div className="help-page">
                <h1 className="page-title">Help</h1>
        </div>);
    };
};

export default Help;
